// extracted by mini-css-extract-plugin
export default {"feedEditDeviceItemsSection":"FeedEditDeviceItems_feedEditDeviceItemsSection__alTNW"};